var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridgreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid_view_grey",
    "data-name": "Grid view grey",
    transform: "translate(-1393 -225)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5325",
    "data-name": "Rectangle 5325",
    width: 20,
    height: 20,
    transform: "translate(1393 225)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65160",
    "data-name": "Group 65160",
    transform: "translate(-190.047 -483.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33694",
    "data-name": "Path 33694",
    d: "M-19039.953-7188.729v13.806h5.17v-13.806Z",
    transform: "translate(20624 7900)",
    fill: "#b5bac1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33695",
    "data-name": "Path 33695",
    d: "M-19030.889-7188.729v6.1h11.582v-6.1Z",
    transform: "translate(20621.297 7900)",
    fill: "#b5bac1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33696",
    "data-name": "Path 33696",
    d: "M-19030.889-7178.192v6.411h5.119v-6.411Z",
    transform: "translate(20621.297 7896.856)",
    fill: "#b5bac1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33697",
    "data-name": "Path 33697",
    d: "M-19021.971-7178.192v6.463h5.219v-6.463Z",
    transform: "translate(20618.635 7896.856)",
    fill: "#b5bac1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridgreyIcon);
export default __webpack_public_path__ + "static/media/gridgreyIcon.3ffa4356382e06142ddfe20b1436949b.svg";
export { ForwardRef as ReactComponent };